
__webpack_require__.S = {};
__webpack_require__.initializeSharingData = { scopeToSharingDataMapping: { "default": [{ name: "@diana/core", version: "1.3.693", factory: function() { return Promise.all([__webpack_require__.e("783"), __webpack_require__.e("354"), __webpack_require__.e("719"), __webpack_require__.e("80"), __webpack_require__.e("136"), __webpack_require__.e("308"), __webpack_require__.e("157"), __webpack_require__.e("902"), __webpack_require__.e("993"), __webpack_require__.e("286"), __webpack_require__.e("329"), __webpack_require__.e("751"), __webpack_require__.e("612"), __webpack_require__.e("632"), __webpack_require__.e("338"), __webpack_require__.e("123")]).then(function() { return function() { return __webpack_require__(14788); }; }); }, eager: 0 }, { name: "@mui/material", version: "5.14.11", factory: function() { return Promise.all([__webpack_require__.e("719"), __webpack_require__.e("308"), __webpack_require__.e("44"), __webpack_require__.e("286"), __webpack_require__.e("329"), __webpack_require__.e("612")]).then(function() { return function() { return __webpack_require__(71711); }; }); }, eager: 0 }, { name: "@mui/styled-engine", version: "5.14.11", factory: function() { return Promise.all([__webpack_require__.e("751"), __webpack_require__.e("78")]).then(function() { return function() { return __webpack_require__(79408); }; }); }, eager: 0 }, { name: "@rise-x/ui", version: "0.2.0", factory: function() { return Promise.all([__webpack_require__.e("269"), __webpack_require__.e("286"), __webpack_require__.e("329"), __webpack_require__.e("313")]).then(function() { return function() { return __webpack_require__(81430); }; }); }, eager: 0 }, { name: "@tanstack/react-query", version: "5.59.20", factory: function() { return Promise.all([__webpack_require__.e("171"), __webpack_require__.e("286")]).then(function() { return function() { return __webpack_require__(68182); }; }); }, eager: 0 }, { name: "react-dom", version: "18.2.0", factory: function() { return function() { return __webpack_require__(78325); }; }, eager: 1 }, { name: "react-router-dom", version: "6.19.0", factory: function() { return Promise.all([__webpack_require__.e("535"), __webpack_require__.e("329")]).then(function() { return function() { return __webpack_require__(53299); }; }); }, eager: 0 }, { name: "react/jsx-dev-runtime", version: "18.2.0", factory: function() { return function() { return __webpack_require__(53746); }; }, eager: 1 }, { name: "react/jsx-runtime", version: "18.2.0", factory: function() { return function() { return __webpack_require__(62540); }; }, eager: 1 }, { name: "react", version: "18.2.0", factory: function() { return function() { return __webpack_require__(63696); }; }, eager: 1 }, { name: "styled-components", version: "5.3.5", factory: function() { return __webpack_require__.e("40").then(function() { return function() { return __webpack_require__(47667); }; }); }, eager: 0 }] }, uniqueName: "diana" };
var initPromises = {};
var initTokens = {};
__webpack_require__.I = function(name, initScope) {
	if (!initScope) initScope = [];
	// handling circular init calls
	var initToken = initTokens[name];
	if (!initToken) initToken = initTokens[name] = {};
	if (initScope.indexOf(initToken) >= 0) return;
	initScope.push(initToken);
	// only runs once
	if (initPromises[name]) return initPromises[name];
	// creates a new share scope if needed
	if (!__webpack_require__.o(__webpack_require__.S, name))
		__webpack_require__.S[name] = {};
	// runs all init snippets from all modules reachable
	var scope = __webpack_require__.S[name];
	var warn = function (msg) {
		if (typeof console !== "undefined" && console.warn) console.warn(msg);
	};
	var uniqueName = __webpack_require__.initializeSharingData.uniqueName;
	var register = function (name, version, factory, eager) {
		var versions = (scope[name] = scope[name] || {});
		var activeVersion = versions[version];
		if (
			!activeVersion ||
			(!activeVersion.loaded &&
				(!eager != !activeVersion.eager
					? eager
					: uniqueName > activeVersion.from))
		)
			versions[version] = { get: factory, from: uniqueName, eager: !!eager };
	};
	var initExternal = function (id) {
		var handleError = function (err) {
			warn("Initialization of sharing external failed: " + err);
		};
		try {
			var module = __webpack_require__(id);
			if (!module) return;
			var initFn = function (module) {
				return (
					module &&
					module.init &&
					module.init(__webpack_require__.S[name], initScope)
				);
			};
			if (module.then) return promises.push(module.then(initFn, handleError));
			var initResult = initFn(module);
			if (initResult && initResult.then)
				return promises.push(initResult["catch"](handleError));
		} catch (err) {
			handleError(err);
		}
	};
	var promises = [];
	var scopeToSharingDataMapping = __webpack_require__.initializeSharingData.scopeToSharingDataMapping;
	if (scopeToSharingDataMapping[name]) {
		scopeToSharingDataMapping[name].forEach(function (stage) {
			if (typeof stage === "object") register(stage.name, stage.version, stage.factory, stage.eager);
			else initExternal(stage)
		});
	}
	if (!promises.length) return (initPromises[name] = 1);
	return (initPromises[name] = Promise.all(promises).then(function () {
		return (initPromises[name] = 1);
	}));
};

